import { z } from 'zod'

import { Address } from '~/utils/address'

export const addressSchema = z
  .string()
  .refine((address) => Address.validate(address), {
    message: 'Invalid address',
  })
  .transform((a) => Address.format(a))
